<template>
  <el-form ref="loadoForm" :model="loadoForm" :rules="loadoRules" label-width="110px">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备型号" prop="deviceModel">
          <el-input
            v-if="!isDetail()"
            v-model="loadoForm.deviceModel"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ loadoForm.deviceModel || '-' }}</span>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="出厂编号" prop="factoryNo">
          <el-input
            v-if="!isDetail()"
            v-model="loadoForm.factoryNo"
            maxlength="50"
            placeholder="请输入"
          ></el-input>
          <span v-else>{{ loadoForm.factoryNo || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="设备状态" prop="status">
          <el-select v-if="!isDetail()" v-model="loadoForm.status" style="width: 100%">
            <el-option
              v-for="item in typeList"
              :key="item.type"
              :label="item.typeName"
              :value="item.type"
            ></el-option>
          </el-select>
          <span v-else>{{ typeObj[loadoForm.status] || '-' }}</span>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      typeList: [
        { type: 0, typeName: '启用' },
        { type: 1, typeName: '停用' }
      ],
      typeObj: {
        0: '启用',
        1: '停用'
      },
      loadoForm: {}
    };
  },
  inject: ['isDetail'],

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.loadoForm = newVal;
      }
    },
    loadoForm: {
      immediate: true,
      deep: true,
      handler: function (newVal) {
        this.$emit('change', newVal);
      }
    }
  },
  computed: {
    loadoRules() {
      return {
        status: [{ required: !this.isDetail(), message: '请选择设备状态', trigger: 'change' }]
      };
    }
  },
  methods: {
    getNationNo() {
      // getNationNum().then(res => {
      //   if (!res.success) {
      //     return;
      //   }
      //   this.loadoForm.mnNum = res.data
      // });
    },
    getData() {
      let data = {
        deviceModel: this.loadoForm.deviceModel,
        factoryNo: this.loadoForm.factoryNo,
        status: this.loadoForm.status
      };
      return data;
    },
    setData(data) {
      const { deviceModel, factoryNo, status } = data;
      this.loadoForm.deviceModel = deviceModel;
      this.loadoForm.factoryNo = factoryNo;
      this.loadoForm.status = status;
    },
    reset() {
      this.$refs.loadoForm.resetFields();
    },
    validate() {
      let type;
      this.$refs.loadoForm.validate(validated => {
        type = validated;
      });
      return type;
    }
  }
};
</script>
